export const bankDetails = [
  { label: "Bank Name", value: "KOTAK MAHINDRA BANK" },
  { label: "Bank A/c Name", value: "ARRKP HOSPITALITY PRIVATE LTD" },
  { label: "Bank A/c No", value: "9550489990" },
  { label: "Bank Branch", value: "KADUGODI" },
  { label: "Bank IFSC Code", value: "KKBK0008167" },
];
